import { Env } from '@app/shared/utils/enums/environment.enum';
import { Environement } from './environment.type';

export const domain = 'https://dev-eus2-rc-vet-vet-webapp.cloud-effem.com';

export const environment: Environement = {
  envName: Env.DEV,
  production: false,
  isStandalone: false,
  scriptEnv: 'VetFoundation',
  bffApiUrl: `https://dev-eus1-rc-vet-vet-bff.cloud-effem.com`,
  productApiUrl: 'https://int-eus2-rcapi-apim.azure-api.net/internal/product',
  vetApiUrl: 'https://int-eus2-rcapi-apim.azure-api.net/internal/vet',
  toolApiUrl: 'https://int-eus2-rcapi-apim.azure-api.net/internal/tool',
  nutritionApiUrl: 'https://int-eus2-rcapi-apim.azure-api.net/internal/nutrition',
  healthNutritionApiUrl: 'https://int-eus2-rcapi-apim.azure-api.net/internal/health-nutrition',
  petOwnersApiUrl: 'https://int-eus2-rcapi-apim.azure-api.net/internal/petOwner',
  coreApiUrl: 'https://int-eus2-rcapi-apim.azure-api.net/internal/core',
  myAccountUrl: 'https://prd-weu1-rc-df-myaccount-app-webapp-uat.cloud-effem.com',
  ciam: {
    apiUrl: 'https://prd-weu1-rc-df-ciam-api-webservice-dev.cloud-effem.com',
    app: 'https://prd-weu1-rc-df-ciam-app-webapp-dev.cloud-effem.com',
    redirectCallback: `https://dev-eus2-rc-vet-vet-webapp.cloud-effem.com`,
  },
  blobUrl: `https://uateus2rcvetfileblob.blob.core.windows.net/configuration`,
  blobQueryParams:
    'sp=r&st=2022-12-14T14:43:31Z&se=2026-04-02T21:43:31Z&spr=https&sv=2021-06-08&sr=c&sig=Gj0P6iNJoYHaRiMgZi1NnEpQlI%2BBQcdwHlY3FU0xx6I%3D',
  blobApiUrl: `https://inteus2rcapivetblob.blob.core.windows.net`,
  apimSubscriptionKey: 'c149679550b94d3589949df0c0cbe00b',
  appInsights: {
    instrumentationKey: '871a6511-390e-48ac-b20b-49cc32e94b5e',
    role: 'vet-foundation-webapp',
    roleInstance: 'eus2-vet-foundation-webapp',
  },
  oktaConfig: {
    issuer: 'https://accountdev.royalcanin.com/oauth2/default',
    clientId: '0oaaxam8hqExiGHuG0x6',
    redirectUri: `${domain}/callback`,
    postLogoutRedirectUri: domain,
    pkce: true,
    maxClockSkew: 900,
    scopes: [
      'groups',
      'openid',
      'profile',
      'email',
      'user.profile:write',
      'user.consent:read',
      'purposes:read',
      'user.consent:collect',
      'user.consent:delete',
      'pets:read',
      'pets:write',
      'companies:read',
      'relations:write',
      'relations:read',
    ],
    tokenManager: {
      autoRenew: true,
      autoRemove: true,
    },
  },
  marsFooterScript: null,
  oneTrustId: '0643c84e-3a70-42c5-b752-f1611aa19742',
  fgsUrl: `https://shopuat.royalcanin.com/de/recommendation`,
};
